import React from "react";

const ExclamationCircleIcon = (props: React.ComponentProps<"svg">) => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill={props?.fill || "none"}
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <circle
      cx="10"
      cy="10"
      r="9"
      fill="currentColor"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <rect
      x="10"
      y="14"
      width="0.01"
      height="0.01"
      stroke={"#000000FF"}
      strokeWidth="3"
      strokeLinejoin="round"
    />
    <path
      d="M10 10L10 6"
      stroke={"#000000FF"}
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default ExclamationCircleIcon;
